module.exports = __webpack_public_path__ + "officialStatic/img/soft028.9dd8c7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/soft028.png
// module id = kO2E
// module chunks = 0